import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const MARKETING_PATHS = ['/', '/contact', '/pricing', '/login', '/signup'];

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const location = useLocation();
  const [isDark, setIsDark] = useState(() => localStorage.getItem('vasari-theme') === 'dark');
  const isMarketing = MARKETING_PATHS.includes(location.pathname);

  useEffect(() => {
    if (isDark && !isMarketing) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDark, isMarketing]);

  const toggleDark = () => {
    setIsDark(prev => {
      const next = !prev;
      localStorage.setItem('vasari-theme', next ? 'dark' : 'light');
      return next;
    });
  };

  // On marketing pages the dark class is always removed, so expose false
  // to consumers so inline styles and logo colors also render in light mode.
  const effectiveDark = isDark && !isMarketing;

  return (
    <ThemeContext.Provider value={{ isDark: effectiveDark, toggleDark }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext) ?? { isDark: false, toggleDark: () => {} };
